import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/operations")({
  component: OperationsLayout,
});

function OperationsLayout() {
  return (
    <RouteGuardPermissions
      permissions={[
        { module: "work_orders", actions: ["read"] },
        { module: "personnel_roles", actions: ["read"] },
      ]}
    >
      <Outlet />
    </RouteGuardPermissions>
  );
}
